{
  "appVersion": "2026-11-04-develop-6720-a887d36",
  "forceUpdate": false
}
